import React, { useEffect, useMemo, useState } from 'react';

import { pushGtmEvent } from 'analytics/gtm';
import { getPageSectionFromPath } from 'analytics/getPageSection';
import useWindowSize from 'hooks/windowSize';
import TourBallon from 'newComponents/NewTour/TourBallon';
import { useTour } from 'hooks/useTour';
import NavbarLink from '../NavbarLink';
import ChangeOfUnit from '../ChangeOfUnit';
import { pages, socials } from './pagesMenu';
import Drawer from '../../Granel/Drawer';

import {
  ArrowTopIcon,
  CompanyContainer,
  Container,
  Content,
  DrawerContainer,
  DrawerContent,
  Logo,
  MenuItemContainer,
  Nav,
  NavContainer,
  NavLogo,
  SocialContainer,
  SocialIcon,
  TopList,
  ContainerWrap,
} from './styles';

type NavbarProps = {
  children: JSX.Element | JSX.Element[];
  openSubMenu?: string;
  withTable?: boolean;
  selected?: string;
};

const Navbar = (props: NavbarProps): JSX.Element => {
  const { openSubMenu, selected, children, withTable } = props;
  const [width] = useWindowSize();
  const size = useMemo(() => width, [width]);
  const [topList, setTopList] = useState(false);

  const { showTour, tourStep, tourType } = useTour();

  const goTop = (): void => {
    const header = document.getElementById('outer-container');
    if (header) {
      header.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const updateHeaderTable = (): void => {
    const headerTable = document.getElementById('headerTable');
    if (headerTable) {
      const scrolled =
        size > 1100
          ? headerTable.getBoundingClientRect().top === 0
          : headerTable.getBoundingClientRect().top <= 56;
      headerTable.style.backgroundColor = scrolled ? '#F2F2F2' : '';
      headerTable.style.boxShadow = scrolled ? '0px 4px 4px #00000014' : '';
      setTopList(scrolled);
    }
  };

  useEffect(() => {
    const header = document.getElementById('outer-container');
    if (header) {
      header.addEventListener('scroll', updateHeaderTable);
    }

    return () => {
      if (header) {
        header.removeEventListener('scroll', updateHeaderTable);
      }
    };
  }, [size]);

  return (
    <ContainerWrap>
      <Container id="headerMobile">
        {size > 1100 ? (
          <NavContainer>
            <Nav showTour={tourStep === 1 && tourType === 'home' && showTour}>
              <NavLogo>
                <Logo
                  src="/static/ultragaz-logo-white.svg"
                  alt="Ultragaz logo"
                />
              </NavLogo>

              <CompanyContainer>
                <ChangeOfUnit />
              </CompanyContainer>

              <MenuItemContainer>
                {pages.map((page) => {
                  const isSelected = page.slug.includes(selected || '');
                  const Icon = page.icon;
                  return (
                    <NavbarLink
                      key={page?.url}
                      page={page}
                      isSelected={isSelected}
                      selected={selected || ''}
                      Icon={Icon}
                      openSub={openSubMenu || ''}
                    />
                  );
                })}
              </MenuItemContainer>

              <SocialContainer>
                {socials?.map((social) => {
                  const Icon = social.icon;

                  return (
                    <SocialIcon
                      key={social.href}
                      href={social.href}
                      target="_blank"
                      aria-label={social.alt}
                      rel="external"
                      onClick={() => {
                        pushGtmEvent({
                          event: 'click_menu_item',
                          eventCategory: 'side menu',
                          eventAction: 'click',
                          eventLabel: social?.alt || 'Rede social',
                          pageSection: getPageSectionFromPath(),
                          elementType: 'button',
                        });
                      }}
                    >
                      <Icon aria-hidden />
                    </SocialIcon>
                  );
                })}
              </SocialContainer>
            </Nav>

            <Content
              id="outer-container"
              className="outer-container-intro"
              withTable={withTable}
            >
              {children && size >= 1100 ? children : null}
            </Content>
          </NavContainer>
        ) : (
          <DrawerContainer>
            <Drawer {...props} selected={selected} openSubMenu={openSubMenu}>
              <DrawerContent>{children || null}</DrawerContent>
            </Drawer>
          </DrawerContainer>
        )}
        <TopList active={topList} onClick={() => goTop()}>
          <ArrowTopIcon />
        </TopList>
      </Container>
      {showTour && tourStep === 1 && tourType === 'home' && (
        <TourBallon
          title="Menu lateral"
          content="Aqui estão disponíveis, de maneira organizada, todas as funcionalidades do portal."
          position={{
            left: '272px',
            right: '0',
            top: '20%',
            arrowPosition: 'left',
            maxWidth: null,
          }}
        />
      )}
    </ContainerWrap>
  );
};

Navbar.defaultProps = {
  openSubMenu: false,
  withTable: false,
  selected: '',
};

export default Navbar;
